import React from "react"
import PropTypes from "prop-types"
import { Button, Flex } from "antd"
import { useTranslation } from "react-i18next"
import styles from "./index.module.css"
import { LANGUAGES } from "./constants"

export default function LanguageFilterDropdown({ value = [], onChange, updateSearchFilters }) {
  const { t } = useTranslation()
  const handleSelect = (lang) => {
    let newValue
    if (value.includes(lang)) {
      newValue = value.filter((l) => l !== lang)
    } else {
      newValue = [...value, lang]
    }
    onChange(newValue)
    if (typeof updateSearchFilters === "function") updateSearchFilters({ language: newValue })
  }

  const handleClear = () => {
    onChange([])
    if (typeof updateSearchFilters === "function") updateSearchFilters({ language: [] })
  }

  return (
    <div className={styles.dropdownContent}>
      <Flex gap={8} wrap="wrap" className="mb-s">
        {LANGUAGES.map((lang) => (
          <Button key={lang} type={value.includes(lang) ? "primary" : "default"} shape="round" onClick={() => handleSelect(lang)}>
            {lang}
          </Button>
        ))}
      </Flex>
      <Button type="link" onClick={handleClear}>
        {t("filterTags.clear")}
      </Button>
    </div>
  )
}

LanguageFilterDropdown.propTypes = {
  value: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  updateSearchFilters: PropTypes.func
}
